<script>
    import Packages from "./components/packages.svelte";
    import Custom   from "./components/custom.svelte";

    import { customExchange } from "stores/toggles";

    import css from "./quotes.css";
</script>

<div class="{`hbox ${css.quotesContainer} ${$customExchange ? css.customActive : ""}`}">
    <Packages exchangeType="gems2gold" />
    <Packages exchangeType="gold2gems" />

    <Custom exchangeType="gems2gold" />
    <Custom exchangeType="gold2gems" />
</div>
